import { apiRequest } from "../util/apiUtils";

export const projectList = async (params) => {
  try {
    const res = await apiRequest("get", `project/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const projectDetails = async (params) => {
  try {
    const res = await apiRequest("get", `project/details`, {
      queries: { id: params.id },
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const projectAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `project/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const projectDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `project/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const projectStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `project/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
